function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../../utils/classNames';
/**
 * The ProductMeta component handles the consistent display of product / game
 * metadata
 *
 * ## Related Components
 * - [Product](../README.md)
 *
 * ## Usage
 * See Product component for usage.
 *
 * ## Props
 */

var ProductMeta = /*#__PURE__*/function (_PureComponent) {
  _inherits(ProductMeta, _PureComponent);

  var _super = _createSuper(ProductMeta);

  function ProductMeta() {
    _classCallCheck(this, ProductMeta);

    return _super.apply(this, arguments);
  }

  _createClass(ProductMeta, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          tags = _this$props.tags,
          name = _this$props.name,
          price = _this$props.price,
          publisherName = _this$props.publisherName,
          editionName = _this$props.editionName,
          releaseDate = _this$props.releaseDate,
          size = _this$props.size,
          variant = _this$props.variant;

      var _ProductMeta$getClass = ProductMeta.getClassName({
        className: className,
        variant: variant,
        size: size
      }),
          root = _ProductMeta$getClass.root,
          titleClass = _ProductMeta$getClass.title,
          tagsClass = _ProductMeta$getClass.tags,
          metaClass = _ProductMeta$getClass.meta;

      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: root
      }, /*#__PURE__*/React.createElement("h2", {
        className: titleClass
      }, name), size !== 'small' && tags && /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#tags"),
        className: tagsClass
      }, tags), editionName && /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#editionName"),
        className: metaClass
      }, editionName), publisherName && /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#publisherName"),
        className: metaClass
      }, publisherName), releaseDate && /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#releaseDate"),
        className: metaClass
      }, releaseDate), price && /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#price")
      }, price));
    }
  }]);

  return ProductMeta;
}(PureComponent);

var cx = classNamesFor(ProductMeta);
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for Product
 */

ProductMeta.getClassName = function (_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      size = _ref.size;
  return {
    root: cx('psw-product__meta', 'psw-l-line-enable-truncation', {
      'psw-fill-x': variant === 'grid'
    }, className),
    title: cx('psw-h5', "psw-truncate-text-".concat(size === 'small' || variant === 'grid' ? '2' : '1')),
    tags: cx('psw-l-space-x-2xs', "psw-truncate-text-".concat(variant === 'list' ? '1' : '2')),
    meta: cx('psw-truncate-text-1')
  };
};
/**
 * Defines aliases for classNames used by this component
 */


ProductMeta.useClassNames = function (classNames) {
  ProductMeta.classNames = classNames;
};

ProductMeta.defaultProps = {
  qa: '',
  className: '',
  tags: null,
  name: '',
  price: '',
  publisherName: '',
  editionName: '',
  releaseDate: '',
  variant: 'list',
  size: 'standard'
};
ProductMeta.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Determines the presentational variant of the Product. If used within a Product
   * component this property will be inherited.
   */
  variant: PropTypes.oneOf(['list', 'grid']),

  /**
   * Size as defined in the Metropolis style guide for Product Tiles. If used within a Product
   * component this property will be inherited.
   */
  size: PropTypes.oneOf(['small', 'standard']),

  /**
   * The list of tags to be displayed for the products as jsx
   */
  tags: PropTypes.node,

  /**
   * The name of the product / game
   */
  name: PropTypes.string,

  /**
   * The price of the game. For more complex price layouts jsx is accepted
   */
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * The publisher name for the game / product
   */
  publisherName: PropTypes.string,

  /**
   * The edition name for the game / product
   */
  editionName: PropTypes.string,

  /**
   * When the game was / is going to be released
   */
  releaseDate: PropTypes.string
};
export default ProductMeta;